// eslint-disable-next-line no-restricted-imports
import { MessageCategoryEnum } from '@eih-netbroker/api-notification';

export const MessageCategory = MessageCategoryEnum;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type MessageCategory = (typeof MessageCategory)[keyof typeof MessageCategory];
